import init from '../../../js/init';
import { Screen } from '../../../js/variables';

const mobileVersionThreshold = Screen.sm;
const animationDuration = 320;

const name = 'primary-menu';
const selector = '.primary-menu';
const itemSelector = `${selector}__item`;
const rootItemsSelector = `${selector}__items--root`;
const submenuSelector = `${selector}__submenu`;
const backBtnSelector = `${selector}__back-btn`;

init(Drupal, name, selector, root => {
  const rootItems = root.querySelector(rootItemsSelector);
  const items = root.querySelectorAll(itemSelector);
  const submenus = root.querySelectorAll(submenuSelector);
  const backButtons = root.querySelectorAll(backBtnSelector);
  let depth = 0;

  const isMobile = () => {
    return window.innerWidth < mobileVersionThreshold;
  };

  const animation = async () => {
    root.style.pointerEvents = 'none';
    document.body.style.overflowX = 'hidden';
    return new Promise(resolve => {
      setTimeout(() => {
        root.style.pointerEvents = '';
        document.body.style.overflowX = '';
        resolve();
      }, animationDuration);
    });
  };

  const updatePosition = async () => {
    rootItems.style.left = `calc(-${depth} * 100vw`;
    await animation();
  };

  const resetPosition = async () => {
    depth = 0;
    submenus.forEach(submenu => (submenu.style.visibility = ''));
    await updatePosition();
  };

  const itemClickListener = async e => {
    e.stopPropagation();
    if (!isMobile()) return;
    const item = e.currentTarget;
    const submenu = item.querySelector(submenuSelector);
    if (!submenu) return;
    submenu.style.visibility = 'visible';
    depth += 1;
    await updatePosition();
  };

  const backBtnClickListener = async e => {
    e.stopPropagation();
    if (!isMobile()) return;
    const btn = e.currentTarget;

    const submenu = btn.closest(submenuSelector);
    depth -= 1;
    await updatePosition();
    submenu.style.visibility = '';
  };

  const onResize = () => {
    if (!isMobile()) {
      resetPosition();
    }
  };

  items.forEach(item => (item.onclick = itemClickListener));
  backButtons.forEach(btn => (btn.onclick = backBtnClickListener));
  window.addEventListener('resize', onResize);
});
